import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  Col,
  Container,
  Modal,
  Row,
} from '@themesberg/react-bootstrap';
import React from 'react';
// import { Modal, Button, Card, Container, Row, Col } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css"; // Ensure Bootstrap is imported

const ResponsiveModal = ({
  show,
  icon,
  title,
  subtitle,
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal show={show} centered size="md" aria-labelledby="responsive-modal">
      <Modal.Body className="m-3">
        <Container fluid>
          <Row className="text-center">
            <Col>
              {icon && (
                <div className="mb-3">
                  <FontAwesomeIcon size="lg" icon={icon} />
                </div>
              )}
              <h5 className="mb-2 font-weight-bold">{title}</h5>
              <p className="text-muted mb-4">{subtitle}</p>
            </Col>
          </Row>

          <div className="d-flex justify-content-between">
            <Button
              className="rounded-0"
              onClick={onCancel}
              style={{
                //   flex: 1,
                marginRight: '0.5rem',
                borderRadius: '4px',
                fontSize: '14px',
                width: '142px',
                // fontWeight: '600',
                backgroundColor: '#F4F4F4',
                border: 'none',
                color: '#4A4A4A',
              }}
            >
              No
            </Button>
            {/* </Col>
            <Col> */}
            <Button
              // variant="danger"
              className="rounded-0"
              onClick={onConfirm}
              style={{
                //   flex: 1,
                marginLeft: '0.5rem',
                borderRadius: '4px',
                fontSize: '14px',
                width: '142px',
                // fontWeight: '600',
                backgroundColor: '#F3D6D7',
                border: 'none',
                color: '#4A4A4A',
              }}
            >
              Yes
            </Button>
            {/* </Col> */}
          </div>
        </Container>
      </Modal.Body>
    </Modal>
  );
};

export default ResponsiveModal;
